import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QueryBuilderState } from '../reducers/queryBuilder.reducer';

export const queryBuilderState: any = createFeatureSelector<QueryBuilderState>('queryBuilder');

export const qbFields = createSelector(queryBuilderState, (state: any) => {
  return state.qbFields;
});

export const qbQueries = createSelector(queryBuilderState, (state: any) => {
  return state.qbQueries;
});

export const qbProperties = createSelector(queryBuilderState, (state: any) => {
  return state.qbProperties;
});

export const allQueries = createSelector(queryBuilderState, (state: any) => {
  return state.allQueries;
});
